import Utils from '../../utils/Utils';
import AbstractPlayer from './AbstractPlayer';
import settings, {
  PONCONNECT,
  PONSTOP,
  PONPLAY,
  PONPAUSE,
  PONSKIP,
  PONSPEED,
  PONBUFFER
} from '../../devices/all/settings';
import * as playerConstant from '../../utils/playerConstants';
import asyncPinObserver from './../../AAF/Pin/AsyncPinObserver';
import AAF from '../../AAF/AAF';
import * as constant from './../../AAFPlayer/constants';
import EventTimeshift from '../../AAF/Timeshift/EventTimeshift';
import { isVMayorIgual519 } from '../../AAFPersistenceManager/helpers/Utils';
import TvChannelUtil from '../../utils/TvChannelUtil';
import Asset from '../../requests/apa/Asset'
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import logger from 'src/utils/logger/logger';

class AbstractHTML5Player extends AbstractPlayer {
  constructor() {
    super();
    this.options = {};
    this._playerContainer = null;
    this._playerHTMLTag = null;
    this._isPrepared = false;
    this._duration = 0;
    this._isOnLoaded = false;
    this.seek_resume = 0;
    this.src = null;

    /* MULTIAUDIO TRACK VARS */
    this.audioTracks = [];
    this.textTracks = [];
    this.currentAudioTrackIndex = null;
    this.currentTextTrackIndex = null;
    this.retryLimitAudioTrack = 20;
    this.retryIntervalAudioTrack = 1; //
    /* END MULTIAUDIO TRACK VARS */

    // Player states, por default onconnect
    this.previousPlayerState = 0;
    this.currentPlayerState = 0;

    this.playerStarts = false;

    this.prependPip = '';

    this.retryIntervalFirstPlaying = 0.9;
    this.retryLimitFirstPlaying = 60;
    this.seekWindow = null;
    this.currentTime = 0;

    this.isSeek = false;
    this.firstLoad = false;

    this.getNowEventCallback = null;

    this.eventTimeshiftIntervalID = null;
    this.eventTimeshiftIntervalMS = 1000;
    this.currentLiveEvent = null;

    this.currentStartOverSeek = null;
    this.nowStartOverSeek = null;
    this.currentGroupId = null;

    /**
     * Trick mode / trick play vars & method
     */
    this.speed_timeoutID = null;
    this.speed_options = EventTimeshift.fastForwardRewindOptions();
    this.speed_value = 0;
    this.speed_justNow = false;
    this.speed_interval = 200;
    this.doing_speed_interval = 50;
    this.speed_direction;
    this.resetFastForwardRewind = this.resetFastForwardRewind.bind(this);
    this.isLanguageCodeByIso2 = this.isLanguageCodeByIso2.bind(this);
  }

  getStateName(state) {
    let nameState = '';

    switch (state) {
      case PONCONNECT:
        nameState = 'PONCONNECT';
        break;
      case PONSTOP:
        nameState = 'PONSTOP';
        break;
      case PONPLAY:
        nameState = 'PONPLAY';
        break;
      case PONPAUSE:
        nameState = 'PONPAUSE';
        break;
      case PONSKIP:
        nameState = 'PONSKIP';
        break;
      case PONSPEED:
        nameState = 'PONSPEED';
        break;
      case PONBUFFER:
        nameState = 'PONBUFFER';
        break;
      default:
        nameState = 'Unknown [' + state + ']';
        break;
    }

    return nameState;
  }

  setCurrentPlayerState(state) {
    this.previousPlayerState = this.currentPlayerState;
    this.currentPlayerState = state;
  }

  getCurrentPlayerState() {
    return this.currentPlayerState;
  }

  setPlayerBackground(urlBackgroundImage) {
    if (!this._playerContainer) return;

    if (urlBackgroundImage) {
      let urlString = "url('" + urlBackgroundImage + "')";
      this._playerContainer.style.backgroundImage = urlString;
      this._playerContainer.style.backgroundRepeat = 'no-repeat';
    } else {
      this._playerContainer.style.backgroundImage = 'none';
    }
  }

  createPlayer(options) {
    this.prependPip = options.isPip ? '_pip' : '_full';
    this._playerContainer = window.document.createElement('div');
    this._playerContainer.style.backgroundColor = 'transparent';
    this._playerContainer.id = 'Html5PlayerContainer' + this.prependPip;
    this._playerContainer.className = 'Html5PlayerContainer';

    if (!this.streamIsImage()) {

      if (options.isTPA) {
        this.setPlayerBackground(options.isTPA.background ? options.isTPA.background : null);
        this.createTPANotice(options.isTPA.notice ? options.isTPA.notice : null);
      }
      else {
        this.setPlayerBackground(options.backgroundImage ? options.backgroundImage : null);
      }

      this._playerHTMLTag = window.document.createElement('video');
      this._playerHTMLTag.setAttribute('id', 'Html5Player' + this.prependPip);

      // Muted only apply to pip, at this moment
      if (options.muted) {
        this._playerHTMLTag.setAttribute('muted', 'muted');
      }

      this._playerHTMLTag.className = 'Html5Player';
      this._playerContainer.appendChild(this._playerHTMLTag);
    }
    else {
      this.setPlayerBackground(options.src ? options.src : null);
    }

    if (!this.options.parentWrapper) {
      logger.error('parentWrapper not found');
      return;
    }

    let vWrapper = document.getElementById(this.options.parentWrapper.id);
    // vWrapper.appendChild(this._playerContainer);
    vWrapper.insertBefore(this._playerContainer, vWrapper.firstChild);

    // Add listeners...if apply
    if (!this.streamIsImage()) {
      !options.isTPA && this.addEventsListeners();
    }
  }

  createTPANotice(notice) {
    // Crea los elementos
    const tpaNoticeContainer = window.document.createElement('div');
    const tpaNoticeContent = window.document.createElement('p');
    const tpaNoticeImage = window.document.createElement('img');

    // Asigna las clases
    tpaNoticeContainer.className = "tpanotice-container";
    tpaNoticeContent.className = "tpanotice-content";
    tpaNoticeImage.className = "tpanotice-image";

    // Asifna el valor a los elementos
    tpaNoticeContent.innerHTML = notice ? notice : '';

    let region = DeviceStorage.getItem('region');
    region = region ? region : '';

    let claroLogo = '';
    const tpaLogoCVRegion = `externalAplication_alert_logo_clarotv_${region}`;
    const tpaLogoCVDefault = 'externalAplication_alert_logo_clarotv';

    const claroLogoRegion = Asset.get(tpaLogoCVRegion);
    if(claroLogoRegion === tpaLogoCVRegion) {
      const claroLogoDefault = Asset.get(tpaLogoCVDefault);
      claroLogo = claroLogoDefault;
    }
    else {
      claroLogo = claroLogoRegion;
    }

    tpaNoticeImage.src = claroLogo ? claroLogo : '';
    // Afrega los elementos hijos al elemento padre
    tpaNoticeContainer.appendChild(tpaNoticeContent);
    tpaNoticeContainer.appendChild(tpaNoticeImage);

    // Agrega el elemento padre al contenedor del player
    this._playerContainer.appendChild(tpaNoticeContainer);
  }

  createMedia(options) {
    if(settings.use_dexie){
      options.src = 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4?t='+Math.random();
    }
    logger.debug('[AbstractHTML5Player] createMedia' /*  , options */);
    //if(typeof options.src === 'undefined' && typeof options.streamType === 'undefined')
    //return;

    if (this._isPrepared) return;

    // Just in case...newSource attr only arrive here when it is a replaceMediaSource (enter in replace method below),
    // so in this path we dont have to have this attr, reset it
    if (options.newSource && options.newSource.src) {
      options.newSource = null;
    }

    this.options = options;
    if (this.options.isPip) {
      // Pip would only exist when this is a video or audio
      this._playerHTMLTag = document.getElementById('Html5Player_pip');
      if (!this._playerHTMLTag) {
        this.createPlayer(options);
      } else {
        this.addEventsListeners();
        this._playerContainer = document.getElementById('Html5PlayerContainer_pip');
        if (!this.streamIsImage()) {
          this.setPlayerBackground(
            options.backgroundImage ? options.backgroundImage : null
          );
        }
        if (options.muted) {
          this._playerHTMLTag.setAttribute('muted', 'muted');
        } else {
          this._playerHTMLTag.removeAttribute('muted');
        }
        if (options.controls) {
          this._playerHTMLTag.setAttribute('controls', 'controls');
        } else {
          this._playerHTMLTag.removeAttribute('controls');
        }
      }
    } else {
      this.createPlayer(options);
    }

    this.hide();
    this._isPrepared = true;
  }

  loadMedia() {
    //if(typeof this.options.src === 'undefined' && typeof this.options.streamType === 'undefined')
    //return;

    logger.debug('[AbstractHTML5Player] loadMedia ', this.options);
    if (!this._isPrepared) {
      return false;
    }
    logger.debug('[AbstractHTML5Player] loadMedia isPrepared');
    if (this.streamIsImage()) {
      return;
    }

    if (this.streamIsVideo() && this.options.resume && !this.options.isLive) {
      this.seek_resume = this.options.resume;
    }

    if (this.options && this.options.groupId) {
      this.currentGroupId = this.options.groupId;
    }

    if (this.options.src) {
      this.src = this.options.src;
      this._isOnLoaded = false;
      let type = null; // TODO Per device
      this.setVideoSource(this.options.src, type);
      this._playerHTMLTag.load();
      if (!this.options.isPip) {
        this.setPlayerFull();
      }
    } else {
      this.destroy();
    }
    logger.debug('[AbstractHTML5Player] loadMedia end');
  }

  setPlayerFull() {
    this.setPlayerSize(0, 0, 1280, 720);
    // TODO check if we need a pause on player, and object ¿?
    // this.sefPlugin.style.position = "relative or fixed ¿?";
  }

  setPlayerSize(top, left, width, height) {
    if (this.options.parentWrapper) {
      let vWrapper = document.getElementById(this.options.parentWrapper.id);
      if (vWrapper && vWrapper.parentNode) {
        vWrapper.parentNode.style.top = top + 'px';
        vWrapper.parentNode.style.left = left + 'px';
        vWrapper.parentNode.style.width = width + 'px';
        vWrapper.parentNode.style.height = height + 'px';
      }
    }

    if (this._playerContainer) {
      this._playerContainer.style.top = '0px';
      this._playerContainer.style.left = '0px';
      this._playerContainer.style.width = width + 'px';
      this._playerContainer.style.height = height + 'px';
      this._playerContainer.style.position = 'relative';
      this._playerContainer.className = 'AbstractPlayerObject'; // We dont use this css...at this moment
    }

    if (this.streamIsAudio()) {
      width = 0;
      height = 0;
      if (this._playerHTMLTag) {
        this._playerHTMLTag.style.top = '0px';
        this._playerHTMLTag.style.left = '0px';
        this._playerHTMLTag.style.width = width + 'px';
        this._playerHTMLTag.style.height = height + 'px';
        this._playerHTMLTag.style.position = 'absolute';
        this._playerHTMLTag.className = 'AbstractPlayerObject'; // We dont use this css...at this moment
      }
    }
  }

  setVideoSource(url, type) {
    logger.debug('******* <<<<<<<<<<< INIT AbstractHTML5Player setVideoSource: ' + url);
    let source = document.createElement('source');
    source.src = url;
    if (type) source.type = type;

    source.id = 'Html5PlayerSource' + (this.options.isPip ? '_pip' : '_full');
    this._playerHTMLTag.appendChild(source);

    logger.debug('******* <<<<<<<<<<< END AbstractHTML5Player setVideoSource');
  }

  play() {
    if (this.streamIsImage()) {
      return;
    }

    logger.debug('******* <<<<<<<<<<< INIT AbstractHTML5Player play');
    this.show();

    this._playerHTMLTag.play();
    logger.debug('******* <<<<<<<<<<< END AbstractHTML5Player play');

    // Sólo para pruebas de youbora
    // setTimeout(() => {
    //     let e = {
    //             target: {
    //                 error: {
    //                     code : 'Hola'
    //                 }
    //             }
    //         };
    //     this._onError(e);
    // }
    //     , 10000);
  }

  resume() {
    logger.debug('******* <<<<<<<<<<< END AbstractHTML5Player resume');
    this._playerHTMLTag.play();
  }

  pause() {
    this.resetFastForwardRewind(true);
    this._playerHTMLTag.pause();
    this.onPlayerStatePause();
    // Send event onStop????
  }

  stop() {
    this.resetFastForwardRewind(true);
    this._playerHTMLTag.pause();
    this.onPlayerStateStop();
    // Send event onStop????
  }

  replaceMediaSource(newSource) {
    this.options.newSource = newSource; // Add the attr to detect error when replace and not reset whole player
    this.options.src = newSource.src;
    this.options.drmInfo = newSource.drmInfo;
    this.options.isLive = newSource.isLive;
    this.options.streamType = newSource.streamType;

    if (newSource.backgroundImage && !this.streamIsAudio()) {
      this.options.backgroundImage = newSource.backgroundImage;
      this.setPlayerBackground(newSource.backgroundImage);
    }

    // If there is a resume when vod...
    if (newSource.resume && !newSource.isLive) {
      this.seek_resume = newSource.resume;
      this.options.resume = newSource.resume;
    }

    // Stop already take care of send stop to player internal state
    // so below, play change to playingstate
    this.stop();

    if (!this.streamIsAudio()) {
      if(!this.options.mundial2026) {
        asyncPinObserver.fire('player_stop');
      }
    }

    let currentSource = document.getElementById(
      'Html5PlayerSource' + (this.options.isPip ? '_pip' : '_full')
    );
    if (currentSource) {
      currentSource.parentNode.removeChild(currentSource);
    }

    this.resetFastForwardRewind(true);

    this.playerStarts = false;

    this.currentLiveEvent = null;
    this.currentStartOverSeek = null;
    this.nowStartOverSeek = null;
    this.currentGroupId = null;
    this.resetProgressForTimeshift();

    this._isOnLoaded = false;
    this.currentAudioTrackIndex = null;
    this.currentTextTrackIndex = null;
    this.audioTracks = [];
    this.textTracks = []
    this.setVideoSource(newSource.src, null);
    this._playerHTMLTag.load();
    // Play ahora se controla desde onresolve AAFPlayer
    //this.play();
  }

  /**
   *  @param timeshiftData = {
   *    backward: isBackward,
   *    // Si es negativo o no, se verifica en video/component, quien es quien decide
   *    // si se va o no a pgm o solo hace seek sobre el actual playing
   *    seektime: second to go to,
   *    maxtimeshiftallowed,
   *    starttime: tiempo inicial en que se pidió el request a getmedia
   *  };
   *
   * @param firstSeek true => se tiene que esperar hasta que el player inicie el playing y luego de esto, se manda el seek.
   *                  false => el player ya esta playeando, sobre el playing se manda el seek (no se espera por el playing).
   */
  // Based on currentTime
  seekTimeshift(timeshiftData, firstSeek) {
    if (!EventTimeshift.isEnabled()) {
      if (firstSeek) {
        this.tryOnFirstTimeshiftSeek(1, timeshiftData);
      } else {
        let seekTime = 0;
        seekTime = this.seekWindow.endTime - timeshiftData.seektime;
        if (seekTime < 1) {
          seekTime = this.seekWindow.startTime + 1; // protect player
        }
        if (seekTime >= this.seekWindow.endTime) {
          seekTime = this.seekWindow.endTime - 1; // protect player
        }
        logger.debug('[TEST PLAYER] intentando seek en seekTimeshift ', seekTime);
        if (seekTime > 0) {
          logger.debug('[TEST PLAYER] enviando seek en seekTimeshift ', seekTime);
          this.seek(seekTime);
        } else {
          logger.debug(
            '[TEST PLAYER] ERROR intentando seek en timeshift <timeshiftData, this.seekWindow> => ',
            timeshiftData,
            this.seekWindow
          );
        }
      }
    }
  }

  async tryOnFirstTimeshiftSeek(currentTry, timeshiftData) {
    if (!EventTimeshift.isEnabled()) {
      let curTime = this.getCurrentTime();
      logger.debug(
        '[TEST PLAYER]> tryOnFirstTimeshiftSeek retry number: [' +
        currentTry +
        '], curTime: ' +
        curTime
      );

      if (isNaN(curTime)) {
        curTime = 0;
      }
      if (curTime <= 0) {
        logger.debug(
          '[TEST PLAYER]> tryOnFirstTimeshiftSeek retry number: [' + currentTry + ']'
        );
        if (currentTry >= this.retryLimitFirstPlaying) {
          throw new Error('Fail to get playing state');
          logger.error('[TEST PLAYER]> Error, Fail to get playing state');
          return;
        }
        await Utils.sleep(this.retryIntervalFirstPlaying);

        return this.tryOnFirstTimeshiftSeek(++currentTry, timeshiftData);
      } else {
        this.seekWindow = {
          startTime: 6, // START IN SECOND 6
          endTime: Math.floor(curTime)
        };
        return this.seekTimeshift(timeshiftData, false);
      }
    }
  }

  // sec in seconds
  seek(seconds) {
    this.isSeek = true;
    logger.debug('Playerinterval abstractPlayer seek de: ' + seconds);
    return this.skip(seconds);
  }

  skip(seconds) {
    this._playerHTMLTag.currentTime = seconds;
  }

  hide() {
    if (this._playerHTMLTag) {
      this._playerHTMLTag.style.visibility = 'hidden';
    }

    //if (this._playerContainer) {
    //this._playerContainer.style.visibility = "hidden";
    //}
  }

  show() {
    logger.debug('AbstractHTML5Player show 1');
    if (this._playerHTMLTag) {
      logger.debug('AbstractHTML5Player show 2');
      this._playerHTMLTag.style.visibility = 'visible';
    }
  }

  destroy() {
    if (!this._isPrepared) {
      return;
    }

    /*
// if we are un epg and did a replace, we dont need to destroy player
// we come from a replace
if(this.options.newSource && this.options.newSource.src) {
  this.currentContentTime = 0;
  return;
}
*/

    this.resetFastForwardRewind(true);

    // Both, pip and full, audio and video, stop and remove listeners
    if (!this.streamIsImage()) {
      this.stop();
      this.removeEventsListener();
    }

    if (this.options.isPip) {
      this.destroyPip();
      if (this.streamIsImage()) {
        this.destroyPlayerContainer();
      }
    } else {
      this.destroyPlayerContainer();
    }

    this.playerStarts = false;

    if (!this.streamIsAudio()) {
      asyncPinObserver.fire('player_stop');
    }

    // Remove background both pip and full
    this.setPlayerBackground(null);

    this.previousPlayerState = PONCONNECT;
    this.currentPlayerState = PONCONNECT;

    this._isPrepared = false;

    this.currentLiveEvent = null;
    this.currentStartOverSeek = null;
    this.nowStartOverSeek = null;
    this.currentGroupId = null;
    this.resetProgressForTimeshift();

    return;
  }

  /**
   * FIXME. lms/live? reporta currentTime?
   * Esta realmente playeando el player? video en pantalla?
   */
  isPlayerPlaying() {
    logger.debug(
      '[AAF BLOCKED CHANNELS] Player isPlayerPlaying: ' +
      (this.playerStarts ? 'TRUE' : 'FALSE')
    );
    return this.playerStarts;
  }

  // For optimize pip playing, we dont destroy pip, we only change source
  destroyPip() {
    if (!this._isPrepared) {
      return;
    }

    // Only remove source and hide player when audio or video
    if (!this.streamIsImage()) {
      let source_dom = document.getElementById('Html5PlayerSource_pip');
      if (source_dom) {
        source_dom.parentNode.removeChild(source_dom);
      }
      this.hide();
    }
  }

  destroyPlayerContainer() {
    if (this._playerContainer) {
      if (this._playerHTMLTag && this._playerHTMLTag.parentNode) {
        this._playerHTMLTag.parentNode.removeChild(this._playerHTMLTag);
      }
      let vWrapper = document.getElementById(this.options.parentWrapper.id);
      vWrapper.removeChild(this._playerContainer);
      this._playerContainer = null;
      this._playerHTMLTag = null;
    }

    this.audioTracks = [];
    this.currentAudioTrackIndex = null;
    this.textTracks = []
    this.currentTextTrackIndex = null;
  }

  addEventsListeners() {
    // Bind first
    this._toBindOnLoad = this._onLoad.bind(this);
    this._toBindOnWaiting = this._onWaiting.bind(this);
    this._toBindOnTimeUpdate = this._onTimeUpdate.bind(this);
    //this._toBindOnWaiting = this._onWaiting.bind(this);
    this._toBindOnPlaying = this._onPlaying.bind(this);
    //this._toBindOnPlaying = this._onPlaying.bind(this);
    this._toBindOnError = this._onError.bind(this);
    this._toBindOnFinished = this._onFinished.bind(this);
    this._toBindOnCanPlay = this._onCanPlay.bind(this);
    this._toBindOnDurationChange = this._onDurationChange.bind(this);
    this._toBindOnRateChange = this._onRateChange.bind(this);

    // Add listeners
    this._playerHTMLTag.addEventListener('loadedmetadata', this._toBindOnLoad);
    this._playerHTMLTag.addEventListener('waiting', this._toBindOnWaiting);
    this._playerHTMLTag.addEventListener('timeupdate', this._toBindOnTimeUpdate);
    this._playerHTMLTag.addEventListener('seeking', this._toBindOnWaiting);
    this._playerHTMLTag.addEventListener('seeked', this._toBindOnPlaying);
    this._playerHTMLTag.addEventListener('playing', this._toBindOnPlaying);
    this._playerHTMLTag.addEventListener('error', this._toBindOnError);
    this._playerHTMLTag.addEventListener('ended', this._toBindOnFinished);
    this._playerHTMLTag.addEventListener('canplay', this._toBindOnCanPlay);
    this._playerHTMLTag.addEventListener('durationchange', this._toBindOnDurationChange);
    this._playerHTMLTag.addEventListener('ratechange', this._toBindOnRateChange);
  }

  removeEventsListener() {
    // Remove listeners
    this._playerHTMLTag.removeEventListener('loadedmetadata', this._toBindOnLoad);
    this._playerHTMLTag.removeEventListener('waiting', this._toBindOnWaiting);
    this._playerHTMLTag.removeEventListener('timeupdate', this._toBindOnTimeUpdate);
    this._playerHTMLTag.removeEventListener('seeking', this._toBindOnWaiting);
    this._playerHTMLTag.removeEventListener('seeked', this._toBindOnPlaying);
    this._playerHTMLTag.removeEventListener('playing', this._toBindOnPlaying);
    this._playerHTMLTag.removeEventListener('error', this._toBindOnError);
    this._playerHTMLTag.removeEventListener('ended', this._toBindOnFinished);
    this._playerHTMLTag.removeEventListener('canplay', this._toBindOnCanPlay);
    this._playerHTMLTag.removeEventListener('durationchange', this._toBindOnDurationChange);
    this._playerHTMLTag.removeEventListener('ratechange', this._toBindOnRateChange);
  }

  seekStartOver(seekTime) {
    //console.log('PAU> AbstractHTML5Payer > seekStartOver, seekTime: ', seekTime);
    this.currentStartOverSeek = seekTime;
    this.nowStartOverSeek = Utils.nowAsTimestampSeconds();

    //console.log('[SPEED PLAYER] PAU4> AbstractHTML5Player > seekTime To: ' + seekTime + ', now = ' + this.nowStartOverSeek);
    this.seek(seekTime);
    if (this.options.events.onSeekStartOver) {
      this.options.events.onSeekStartOver(seekTime);
    }
  }

  _calculateCurrentTimeTS(playerCurrentTime) {
    if (EventTimeshift.isEnabled()) {
      if (this.currentLiveEvent) {
        if (this.options.currentContentType === constant.AAF_CONTENT_IS_TV) {
          let now = Utils.nowAsTimestampSeconds();
          // console.log('[TS STV] Currenttime now: ', now);
          // console.log('[TS STV] Currenttime live event end: ', this.currentLiveEvent.date_end);
          if (now > this.currentLiveEvent.date_end) {
            // Pasa al siguiente evento
            this.currentLiveEvent = null;
            //console.log('[TS STV] Va por el siguiente evento!! ***********');
            this.getNowEvent();
          } else {
            //console.log('[TS STV] PAU4> AbstractHTML5Player > Time: ' + Math.round(now - this.currentLiveEvent.date_begin));
            return Math.round(now - this.currentLiveEvent.date_begin);
          }
        }

        if (this.options.currentContentType === constant.AAF_CONTENT_IS_STARTOVER) {
          if (this.currentStartOverSeek !== null) {
            let now = Utils.nowAsTimestampSeconds();
            if (this.nowStartOverSeek === null) {
              //console.log('PAU> AbstractHTML5Player first getCurrentTime: ', this.currentStartOverSeek);
              this.nowStartOverSeek = now;

              return this.currentStartOverSeek;
            }
            // En segundos
            let diff = now - this.nowStartOverSeek;
            let currentcTime = Math.round(this.currentStartOverSeek + diff);

            let dur = this.currentLiveEvent.date_end - this.currentLiveEvent.date_begin;
            //const threshold_seconds = 0.5 * 60; // medio min
            //currentcTime = currentcTime + threshold_seconds;
            if (currentcTime > dur) {
              logger.debug('PAU4> AbstractHTML5Player > Jump to live');
              this.currentLiveEvent = null;
              if (this.options.events.onSkipToLive) {
                this.options.events.onSkipToLive(this.currentGroupId, {
                  group_id: this.currentGroupId
                });
              }
              return;
            } else {
              return currentcTime;
            }
          }
        }
      }
      else {
        return playerCurrentTime;
      }
    }
    else {
      return playerCurrentTime;
    }
  }

  getCurrentTime() {
    if (EventTimeshift.isEnabled()) {
      if (this.currentLiveEvent) {
        if (this.options.currentContentType === constant.AAF_CONTENT_IS_TV) {
          let now = Utils.nowAsTimestampSeconds();
          // console.log('[TS STV] Currenttime now: ', now);
          // console.log('[TS STV] Currenttime live event end: ', this.currentLiveEvent.date_end);
          if (now > this.currentLiveEvent.date_end) {
            // Pasa al siguiente evento
            this.currentLiveEvent = null;
            //console.log('[TS STV] Va por el siguiente evento!! ***********');
            this.getNowEvent();
          } else {
            //console.log('[TS STV] PAU4> AbstractHTML5Player > Time: ' + Math.round(now - this.currentLiveEvent.date_begin));
            return Math.round(now - this.currentLiveEvent.date_begin);
          }
        }

        if (this.options.currentContentType === constant.AAF_CONTENT_IS_STARTOVER) {
          if (this.currentStartOverSeek !== null) {
            let now = Utils.nowAsTimestampSeconds();
            if (this.nowStartOverSeek === null) {
              //console.log('PAU> AbstractHTML5Player first getCurrentTime: ', this.currentStartOverSeek);
              this.nowStartOverSeek = now;

              return this.currentStartOverSeek;
            }
            // En segundos
            let diff = now - this.nowStartOverSeek;
            let currentcTime = Math.round(this.currentStartOverSeek + diff);

            let dur = this.currentLiveEvent.date_end - this.currentLiveEvent.date_begin;
            //const threshold_seconds = 0.5 * 60; // medio min
            //currentcTime = currentcTime + threshold_seconds;
            if (currentcTime > dur) {
              logger.debug('PAU4> AbstractHTML5Player > Jump to live');
              this.currentLiveEvent = null;
              if (this.options.events.onSkipToLive) {
                this.options.events.onSkipToLive(this.currentGroupId, {
                  group_id: this.currentGroupId
                });
              }

              return;
            } else {
              //console.log('PAU4> AbstractHTML5Player > this.currentStartOverSeek: ' + this.currentStartOverSeek);

              return currentcTime;
            }
          }
        }
      }
    }

    if (this._playerHTMLTag) {
      //console.log('PAU> current time normal');
      return this._playerHTMLTag.currentTime;
    }

    return 0;
  }

  getCurrentTimeBack() {
    if (EventTimeshift.isEnabled()) {
      if (this.currentLiveEvent) {
        if (this.options.currentContentType === constant.AAF_CONTENT_IS_TV) {
          const now = Utils.nowAsTimestampSeconds();
          if (now > this.currentLiveEvent.date_end) {
            // Pasa al siguiente evento
            this.currentLiveEvent = null;
            this.getNowEvent();
          } else {
            logger.debug(
              'PAU> AbstractHTML5Player > Time: ' +
              Math.round(now - this.currentLiveEvent.date_begin)
            );
            return Math.round(now - this.currentLiveEvent.date_begin);
          }
        }

        if (this.options.currentContentType === constant.AAF_CONTENT_IS_STARTOVER) {
          if (this.currentStartOverSeek !== null) {
            const now = Utils.nowAsTimestampSeconds();

            if (this.nowStartOverSeek === null) {
              logger.debug(
                'PAU> AbstractHTML5Player first getCurrentTime: ',
                this.currentStartOverSeek
              );
              this.nowStartOverSeek = now;
              return this.currentStartOverSeek;
            }

            let timeOffset = now - this.nowStartOverSeek;
            let currentcTime = Math.round(this.currentStartOverSeek + timeOffset);
            const threshold_seconds = 0.5 * 60; // medio min
            if (
              currentcTime + threshold_seconds + this.currentLiveEvent.date_begin >
              this.currentLiveEvent.date_end
            ) {
              // Jump to live
              logger.debug('PAU> AbstractHTML5Player > Jump to live');
              this.currentLiveEvent = null;
              if (this.options.events.onSkipToLive) {
                this.options.events.onSkipToLive(this.currentGroupId, {
                  group_id: this.currentGroupId
                });
              }
              return;
            } else {
              logger.debug(
                'PAU> AbstractHTML5Player second or more getCurrentTime: ',
                Math.round(
                  this.currentStartOverSeek + (now - this.nowStartOverSeek)
                )
              );
              return currentcTime;
            }
          }
        }
      }
    }

    if (this._playerHTMLTag) {
      //console.log('PAU> current time normal');
      return this._playerHTMLTag.currentTime;
    }

    return 0;
  }

  getDuration() {
    return this._duration;
  }

  setDuration() {
    //Para eventos pasados el player de Sony envía Infinity en lugar de valores numericos, se pone un default.
    if (this._playerHTMLTag.duration === Infinity) {
      //Valor equivalente en string a --:--:--
      this._duration = 0;
    } else {
      this._duration = this._playerHTMLTag.duration;
    }
  }

  doVideoResume() {
    logger.debug(
      '[Player HTML5] onTimeUpdate >>>>>>>>>>>>>>> doVideoResume seek_resume: ',
      this.seek_resume
    );
    if (this.seek_resume <= 0) {
      return;
    }
    logger.debug(
      '[Player HTML5] onTimeUpdate >>>>>>>>>>>>>>> doVideoResume seek_resume, current time before: ',
      this.getCurrentTime()
    );
    this._playerHTMLTag.currentTime = this.seek_resume;
    // Check on devices if we will require a delay here...
    this.seek_resume = 0;
    logger.debug(
      '[Player HTML5] onTimeUpdate >>>>>>>>>>>>>>> doVideoResume seek_resume, current time after: ',
      this.getCurrentTime()
    );
  }


 _fireNowEvent() {
  if (!this.streamIsAudio()) {
    if (!this.playerStarts) {
      logger.debug('PAU> _onLoad');
      if(!this.options.mundial2026) {
        asyncPinObserver.fire('player_starts');
      }
      if (EventTimeshift.isEnabled()) {
        this.getNowEvent();
      }

      this.playerStarts = true;
    }
  }
 }

  /* Events */
  _onLoad() {
    logger.debug('[PLAYR EVENT] _onLoad ', this.getCurrentPlayerState());

    if (this.getCurrentPlayerState() === PONBUFFER) {
      logger.debug('[PLAYR EVENT] _onLoad ---- end buffering');
      this._onBufferingFinish();
    }

    if (this.options.events.onLoad) {
      this.options.events.onLoad();
    }

  }

  _onWaiting() {
    logger.debug('[PLAYR EVENT] _onWaiting');
    if (this.options.events.onWaiting) {
      this.options.events.onWaiting();
    }

    if (!this.streamIsAudio) {
      if (
        !this.firstLoad ||
        this.options.audiosubtitleinfo.optionId !== this.previousAudio ||
        this.isSeek ||
        this.options.groupId !== this.previousGroupId
      ) {
        this._onBufferingStart();
      }

      this.previousAudio = this.options.audiosubtitleinfo.optionId;
      this.previousGroupId = this.options.groupId;
      this.isSeek = false;
      this.firstLoad = true;
    }
    // this.flag++;
  }

  _onTimeUpdate() {
    let ctime = this.getCurrentTime();
    let ctimeForSubtitles = ctime * 1000;
    if(ctime > 0 ){
      this._fireNowEvent();
    }
    //console.error('PAU2> onTimeUpdate: ', ctime);
    if (this.options.events.onTimeUpdate && this.getCurrentPlayerState() !== PONPAUSE) {
      this.options.events.onTimeUpdate(ctime, ctimeForSubtitles);
    }
  }

  _onPlaying() {
    logger.debug('[PLAYR EVENT] _onPlaying', this.getCurrentPlayerState());
    if (this.getCurrentPlayerState() === PONBUFFER && this._isOnLoaded) {
      logger.debug('[PLAYR EVENT] _onPlaying.....previo: buffering');
      this._onBufferingFinish();
    } else {
      this.onPlayerStatePlay();
      logger.debug('[PLAYR EVENT] _onPlaying.....pasa a play');
    }
    if (this.options.events.onPlaying) {
      this.options.events.onPlaying();
    }
  }

  _onError(e) {
    logger.error('[PLAYR EVENT] _onError');
    logger.error(e);
    // From https://dev.w3.org/html5/spec-author-view/video.html
    let msg = '';
    switch (e.target.error.code) {
      case e.target.error.MEDIA_ERR_ABORTED:
        msg = 'User aborted the video playback.';
        break;
      case e.target.error.MEDIA_ERR_NETWORK:
        msg = 'A network error caused the video download to fail part-way.';
        break;
      case e.target.error.MEDIA_ERR_DECODE:
        msg =
          'The video playback was aborted due to a corruption problem or because the video used features your browser did not support.';
        break;
      case e.target.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
        msg =
          'The media resource indicated by the src attribute or assigned media provider object was not suitable.';
        break;
      default:
        msg = 'An unknown error occurred.';
        break;
    }
    this.stop();

    if (this.options.events.onError) {
      this.options.events.onError(msg, playerConstant.onRenderError);
    }
  }

  _onFinished() {
    logger.debug('[PLAYR EVENT] _onFinished');
    this.onPlayerStateStop();
    // Reinit player
    this.destroy();
    if (this.options.events.onFinished) {
      this.options.events.onFinished();
    }
  }

  _onCanPlay(e) {
    logger.debug('[Playercontrols] _onCanPlay> ');
    if (this.options.events.onCanPlay) {
      this.options.events.onCanPlay(e);
    }
    //this._playerHTMLTag.play();
  }

  _onDurationChange() {
    logger.debug('[PLAYR EVENT] _onDurationChange');
    this._isOnLoaded = true;
    this.setDuration();
    this.doVideoResume();
    if (this.options.events.onDurationChange) {
      this.options.events.onDurationChange();
    }
  }

  _onRateChange(evt) {
    logger.debug('[SPEED PLAYER] [PLAYR EVENT] _onRateChange');
    if (this.options.events.onRateChange) {
      this.options.events.onRateChange(evt);
    }
  }

  _onBufferingStart() {
    this.onPlayerStateBuffer();

    if (this.options.events.onBufferingStart) {
      this.options.events.onBufferingStart();
    }
  }

  _onBufferingProgress() {
    if (this.options.events.onBufferingProgress) {
      this.options.events.onBufferingProgress();
    }
  }

  _onBufferingFinish() {
    if (this.options.events.onBufferingFinish) {
      this.options.events.onBufferingFinish();
    }

    // If stop and ends buffering, nothing to do
    if (this.getCurrentPlayerState() === PONSTOP) {
      return;
    }

    // If current state is on connecting, then we go to play
    if (this.getCurrentPlayerState() === PONCONNECT) {
      this.onPlayerStatePlay();
    } else {
      // Set same state as last
      this.setCurrentPlayerState(this.previousPlayerState);
    }
  }

  /* END Events */

  /* PLAYER STATE EVENTS */
  onPlayerStateConnect() {
    this.setCurrentPlayerState(PONCONNECT);
  }

  onPlayerStatePlay() {
    this.setCurrentPlayerState(PONPLAY);
  }

  onPlayerStatePause() {
    this.setCurrentPlayerState(PONPAUSE);
  }

  onPlayerStateStop() {
    this.setCurrentPlayerState(PONSTOP);
  }

  onPlayerStateSkip() {
    this.setCurrentPlayerState(PONSKIP);
  }

  onPlayerStateSpeed() {
    this.setCurrentPlayerState(PONSPEED);
  }

  onPlayerStateBuffer() {
    this.setCurrentPlayerState(PONBUFFER);
  }
  /* END PLAYER STATE EVENTS */

  /* MULTIPLE AUDIOTRACKS */
  async tryGetAudioTracks(currentTry) {
    if (!this._isOnLoaded) {
      logger.debug(
        '[ABSTRACTPLAYER AUDIOTRACK]> tryGetAudioTracks retry number: [' +
        currentTry +
        '] - ABSTRACTPLAYER player audioTracks...'
      );
      if (currentTry >= this.retryLimitAudioTrack) {
        this._toBindOnError({ target: { error: { code: '' } } });
        throw new Error('Fail to get audioTracks');
        logger.error('[ABSTRACTPLAYER]> Error, player instance could not initialize');
        return;
      }

      // Wait for a while...
      await Utils.sleep(this.retryIntervalAudioTrack);

      // ...Continue recursive...
      return this.tryGetAudioTracks(++currentTry);
    } else {
      logger.debug(
        '[ABSTRACTPLAYER AUDIOTRACK]> tryToGetAudioTracks retry number: [' +
        currentTry +
        '] -  ABSTRACTPLAYER player audiioTracks is READY'
      );

      return this.getAudioTracks();
    }
  }

  getAudioTracks() {
    logger.debug('[ABSTRACTPLAYER AUDIOTRACK]');
    if (!this._isOnLoaded) {
      logger.debug('[ABSTRACTPLAYER AUDIOTRACK] Delay 1s to get the audio track info again');
      // ...Start recursive...
      return this.tryGetAudioTracks(1);
    }

    return this.getAudioTrackById();
  }

  getAudioTrackById() {
    logger.debug('[ABSTRACTPLAYER] html5plauyerstgy getAudioTrackById>');

    return new Promise((resolve, reject) => {
      let audioTracks = this._playerHTMLTag.audioTracks;
      let textTracks = this._playerHTMLTag.textTracks;
      let i = 0;
      this.audioTracks = [];
      this.textTracks = [];

      // Valida si el video tag devuelve audioTracks conforme al tipo de contenido
      if (typeof audioTracks === 'undefined' || audioTracks === 'undefined') {
        logger.debug('[ABSTRACTPLAYER] audioTracks no definidos');
        resolve(this.audioTracks);
      }

      if (audioTracks) {
        logger.debug('[ABSTRACTPLAYER] audioTracks recuperados:');
        logger.debug(audioTracks);

        for (i = 0; i < audioTracks.length; i++) {
          let oneTrack = audioTracks[i];
          logger.debug(
            '[ABSTRACTPLAYER] HTML5PlayerMultiAudioTrack track id> ' + oneTrack.id
          );
          logger.debug(
            '[ABSTRACTPLAYER] > ' +
            oneTrack +
            ', label: ' +
            oneTrack.label +
            ', language: ' +
            oneTrack.language
          );

          if (oneTrack.enabled) {
            this.currentAudioTrackIndex = i;
          }

          this.audioTracks.push(oneTrack);
          resolve(this.audioTracks);
        }
      } else {
        reject('Dont have audio tracks!');
      }
      logger.debug(this.audioTracks);

      if (textTracks) {
        for (i = 0; i < textTracks.length; i++) {
          let oneTrack = textTracks[i];
          logger.debug(
            '[ABSTRACTPLAYER] HTML5PlayerMultiTextTrack track id> ' + oneTrack.id
          );
          logger.debug(
            '[ABSTRACTPLAYER] > ' +
            oneTrack +
            ', label: ' +
            oneTrack.label +
            ', language: ' +
            oneTrack.language
          );

          if (oneTrack.mode === 'showing') {
            this.currentTextTrackIndex = i;
          }

          this.textTracks.push(oneTrack);
          resolve(this.textTracks);
        }
      } else {
        reject('Dont have text tracks!');
      }
      logger.debug(this.textTracks);
    });
  }

  // @codeTrack iso id i.e.: esp, eng, por, ori
  setAudioTrack(codeTrack) {
    return new Promise((resolve, reject) => {
      if (!this._isOnLoaded) {
        reject('Dont have audioTracks information');
      }

      let id = parseInt(codeTrack, 10);
      let internalAudioIndex = this.getAudioIndexOfCode(codeTrack);
      if (internalAudioIndex < 0) {
        reject('Dont have audioTracks information, index lang does not exist');
      } else {
        if (this.currentAudioTrackIndex === internalAudioIndex) {
          logger.debug('[ABSTRACTPLAYER AUDIOTRACK] Same audioTrack, nothing to do');
          resolve(true);
        }

        let currentTime = Math.floor(this.getCurrentTime());

        if (this.currentAudioTrackIndex) {
          this.audioTracks[this.currentAudioTrackIndex].enabled = false;
        } else {
          for (let t = 0; t < this.audioTracks.length; t++)
            this.audioTracks[t].enabled = false;
        }

        logger.debug(
          '[ABSTRACTPLAYER AUDIOTRACK] Set audioTrack to index: ' +
          internalAudioIndex +
          ', lang code: ' +
          codeTrack
        );
        this.currentAudioTrackIndex = internalAudioIndex;
        // TODO check if thos works or do we have to use player.audioTracks instead?
        this.audioTracks[internalAudioIndex].enabled = true;
        // this.seek(currentTime);

        resolve(true);
      }
    });
  }

  // @codeTrack iso id i.e.: esp, eng, por, ori
  setAudioTrackLive(codeTrack, subtitleTrack) {
    logger.debug('setAudioTrackLive - Params', codeTrack, subtitleTrack)
    let i = 0

    if (typeof codeTrack == 'string') {
      // Change audio track
      if (this.audioTracks) {
        for (i = 0; i < this.audioTracks.length; i++) {
          if (this.audioTracks[i].language === codeTrack) {
            this.audioTracks[i].enabled = true;
          } else {
            this.audioTracks[i].enabled = false;
          }
        }
        for (i = 0; i < this.audioTracks.length; i++) {
          logger.debug(this.audioTracks[i].label, this.audioTracks[i].language, this.audioTracks[i].enabled)
        }
      }
    }

    if (typeof subtitleTrack == 'string') {
      // Change subtitles track
      if (this.textTracks) {
        for (i = 0; i < this.textTracks.length; i++) {
          if (this.textTracks[i].language === subtitleTrack) {
            this.textTracks[i].mode = "showing";
          } else {
            this.textTracks[i].mode = "hidden";
          }
        }
        for (i = 0; i < this.textTracks.length; i++) {
          logger.debug(this.textTracks[i].label, this.textTracks[i].language, this.textTracks[i].mode)
        }
      }
    }

    // // Change subtitles track (manual Cues)
    // const track = this._playerHTMLTag.addTextTrack("subtitles", "Subtítulos de ejemplo", "en");
    // track.mode = "showing";
    // track.addCue(new VTTCue(0, 20, "[Ejemplo]"));
    // track.addCue(new VTTCue(21, 30, "Este es otro subtítulo"));
    // track.addCue(new VTTCue(31, 40, "Acá uno subtítulo mas"));

    // for (let t = 0; t < this.textTracks.length; t++) {
    //   console.log(
    //     "activeCues:", this.textTracks[t].activecues, "cues:", this.textTracks[t].cues, "id:", this.textTracks[t].id, "inBandMetadataTrackDispatchType:", this.textTracks[t].inBandMetadataTrackDispatchType, "kind:", this.textTracks[t].kind,
    //     "label:", this.textTracks.label, "language:", this.textTracks.language, "mode:", this.textTracks.mode, "default:", this.textTracks.default
    //   )
    // }
  }

  getAudioIndexOfCode(codeTrack) {
    return this.audioTracks.findIndex(track => track.language === codeTrack);
  }

  isLanguageCodeByIso2() {
    let ret = false;
    // ie.> label: audio_ori, language: or
    // ie.> label: audio_por, language: pt
    if (this.audioTracks && this.audioTracks[0]) {
      if (this.audioTracks[0].language.length === 2) {
        ret = true;
      }
    }

    return ret;
  }

  getLanguageCodeByISO3(codeTrack) {
    let ret = null;
    switch (codeTrack) {
      case 'ori':
        ret = 'or';
        break;
      case 'eng':
        ret = 'en';
        break;
      case 'spa':
        ret = 'es';
        break;
      case 'por':
        ret = 'pt';
        break;
      default:
        break;
    }
    logger.debug(`[PLAYER MIDDLEWARE] ${codeTrack} replaced to ${ret}`);
    return ret;
  }

  // Para samsung híbridas...hasta este momento...
  getLanguageCodeByISO2(codeTrack) {
    let ret = null;
    switch (codeTrack) {
      case 'or':
        ret = 'ori';
        break;
      case 'en':
        ret = 'eng';
        break;
      case 'sp':
      case 'es':
        ret = 'spa';
        break;
      case 'po':
      case 'pt':
        ret = 'por';
        break;
      default:
        break;
    }
    logger.debug(`[AbstractPlayer] ${codeTrack} replaced to ${ret}`);
    return ret;
  }

  /* END MULTIPLE AUDIOTRACKS */

  /* UTILS FOR PLAYER */
  streamIsVideo() {
    if (
      this.options.streamType === playerConstant.SS ||
      this.options.streamType === playerConstant.SS_MA ||
      this.options.streamType === playerConstant.HLS ||
      this.options.streamType === playerConstant.HLSPRM ||
      this.options.streamType === playerConstant.HLS_KR ||
      this.options.streamType === playerConstant.DVBC ||
      this.options.streamType === playerConstant.IP_MULTICAST ||
      this.options.streamType === playerConstant.IP_MULTICAST_UDP ||
      this.options.streamType === playerConstant.DVBS ||
      this.options.streamType === playerConstant.WVC
    ) {
      return true;
    } else return false;
  }

  streamIsAudio() {
    if (
      this.options.streamType === playerConstant.AUDIO ||
      this.options.streamType === playerConstant.RADIO
    )
      return true;
    else return false;
  }

  streamIsImage() {
    return this.options.streamType === playerConstant.PLAYERIMAGE;
  }

  streamIsSpot() {
    return this.options.streamType === playerConstant.SPOT;
  }
  /* END UTILS FOR PLAYER */

  consol(msg) {
    logger.debug(
      '======================================================================================== ' +
      msg
    );
  }

  // Timeshift nueva experiencia
  getNowEvent() {
    const currentGroupId = TvChannelUtil.getLastChannel();
    if (this.ifFireProgressForTimeshift() && AAF.Timeshift.hasTimeshift(currentGroupId)) {
      //this.consol('AbstractHTML5Player getNowEvent 2');
      this.getNowEventCb = this.getNowEventCb.bind(this);
      AAF.Timeshift.getNowEvent(currentGroupId, this.getNowEventCb);
    } else {
      if (this.options.events.onTimeshiftEvent) {
        this.options.events.onTimeshiftEvent(null);
      }
    }
  }

  getNowEventCb(event) {
    // this.consol('AbstractHTML5Player getNowEventCb: ' + JSON.stringify(event, null, 4));
    this.currentLiveEvent = event;

    if (this.options.timeshiftData && !isNaN(this.options.timeshiftData.seektime)) {
      // console.log('PAU> AbstractHTML5Payer > getNowEventCb, hay un seek pendiente a las ' + Date.now() + ', ' + new Date());
      // console.log('PAU> AbstractHTML5Payer > getNowEventCb, hay un seek pendiente de hacer a: ', this.options.timeshiftData.seektime);
      // FIXME. Cambiar este a un observer en video/index
      if (!isVMayorIgual519()) {
        this.seekStartOver(this.options.timeshiftData.seektime);
      }
    }

    if (this.options.events.onTimeshiftEvent && event) {
      this.consol('AbstractHTML5Player getNowEventCb sending onTimeshiftEvent');
      this.options.events.onTimeshiftEvent({ event, playerOptions: this.options });
    }
    if (this.getNowEventCallback) {
      this.getNowEventCallback(event);
    }
  }

  ifFireProgressForTimeshift() {
    this.resetProgressForTimeshift();

    if (this.options.currentContentType === constant.AAF_CONTENT_IS_STARTOVER) {
      if (
        this.options.playerMedia &&
        this.options.playerMedia.entry &&
        this.options.playerMedia.entry.startTime
      ) {
        this.options.starttime = this.options.playerMedia.entry.startTime.substring(0, 10);
      }
      if (
        this.options.playerMedia &&
        this.options.playerMedia.entry &&
        this.options.playerMedia.entry.endTime
      ) {
        this.options.endtime = this.options.playerMedia.entry.endTime.substring(0, 10);
      }
    }

    return AAF.Timeshift.ifFireProgressForTimeshift(
      this.options.currentContentType,
      this.options.starttime,
      this.options.endtime
    );
  }

  fireProgressForTimeshift(event) {
    this.resetProgressForTimeshift();
    this.eventTimeshiftIntervalID = setInterval(() => {
      /*
ileft = Math.round(
  (_now - startTime) / timewin_length * EpgConstants.ROW_WIDTH);
*/
    }, this.eventTimeshiftIntervalMS);
  }

  resetProgressForTimeshift() {
    if (this.eventTimeshiftIntervalID) clearInterval(this.eventTimeshiftIntervalID);
  }

  // direction = true => forward
  // direction = false => backward
  setSpeed(direction) {
    //console.log('[NAY] Enter setSpeed with direction ' + (direction ? 'FORWARD' : 'BACKWARD'));
    let playerState = this.getCurrentPlayerState();
    if (this.speed_timeoutID) {
      return;
    }
    if (this.speed_justNow) {
      return;
    }

    this.speed_direction = direction;
    //console.log('[NAY] Enter setSpeed ' + (direction ? 'FORWARD' : 'BACKWARD'));
    this.speed_justNow = true;
    // Calcular siguiente speed value
    this.setSpeedValue(direction);
    // Set speed
    this.handleSpeed();
  }

  handleSpeed() {
    //console.log('[NAY] Enter handle speed');
    this.speed_timeoutID = setTimeout(() => {
      //console.log('[SPEED PLAYER] Enter handle speed primer timeout, clics uno tras otro? que espere el user impaciente :)');
      setTimeout(() => {
        //console.log('[SPEED PLAYER] Enter handle speed segundo timeout, espera 50 ms más para enviar (proteger) finalmente el set speed al player');
        this.doFastForwardRewind();
      }, this.doing_speed_interval); // Este interval debe ser menor que this.speed_interval
      this.speed_timeoutID = null;
    }, this.speed_interval);
  }

  doFastForwardRewind() {
    //console.log('[SPEED PLAYER] Enter doFastForwardRewind');
    this.setPlayerSpeed(this.speed_value);
    this.speed_justNow = false;
  }

  resetFastForwardRewind(ifSendEvent) {
    this.speed_value = 0;
    if (this.speed_timeoutID) {
      clearTimeout(this.speed_timeoutID);
    }
    this.speed_timeoutID = null;
    this.speed_justNow = false;
    // No importa lo que se settee aquí
    this.speed_direction = false;
    // Event para desaparecer el fastplayback container en caso de que esté en pantalla

    if (ifSendEvent) {
      this._onRateChange({ speed: 0, direction: 'BACKWARD' });
    }
  }

  setPlayerSpeed(speed) {
    // console.log('[SP PLAYER] Enter setPlayerSpeed ' + speed + ' - '  + this.speed_direction);
    // console.log('[SPEED PLAYER] Enter setPlayerSpeed num 2 ' + speed);
    if (speed === 0) {
      // Reset Values
      this.resetFastForwardRewind(false);
      this._playerHTMLTag.playbackRate = 1;
    } else {
      //console.log('[SPEED PLAYER] Enter setPlayerSpeed setting playbackRate' + speed);
      try
      {
        this._playerHTMLTag.playbackRate = speed;
      }
      catch(error)
      {
        logger.error('playbackRate  error:', error)
      }

    }
    //console.log('[SPEED PLAYER]Enter setPlayerSpeed before event onRateChange');
    this._onRateChange({
      speed: speed,
      direction: this.speed_direction ? 'FORWARD' : 'BACKWARD'
    });
  }

  setSpeedValue(direction) {
    let modeFullCircular = false;

    /**
     * Proteger player, en caso de que speed options no estén correctamente setteadas
     */
    if (!this.speed_options) this.speed_options = EventTimeshift.fastForwardRewindOptions();
    if (!this.speed_options) return;

    let currSpeedIndex = this.speed_options.indexOf(Math.abs(this.speed_value));
    let newSpeedIndex = 0;
    // speed FORWARD
    if (direction) {
      if (this.speed_value < 0) {
        /**
         * Modo 100% circular en ambos extremos: << & >>
         */
        if (modeFullCircular) {
          newSpeedIndex = currSpeedIndex - 1;
          this.speed_value = -this.speed_options[newSpeedIndex];
        } else {
          /**
           * Modo circular sólo en los extremos, sólo circular en << y en >>
           */
          // Reset si estaba previamente en negativo (backward), restart/inicia hacía adelante
          newSpeedIndex = 0;
          this.speed_value = this.speed_options[newSpeedIndex];
        }
      } else {
        newSpeedIndex =
          currSpeedIndex === this.speed_options.length - 1 ? currSpeedIndex : currSpeedIndex + 1;
        this.speed_value = this.speed_options[newSpeedIndex];
      }
    }
    // speed BACKWARD
    else {
      if (this.speed_value > 0) {
        /**
         * Modo 100% circular en ambos extremos: << & >>
         */
        if (modeFullCircular) {
          newSpeedIndex = currSpeedIndex - 1;
          this.speed_value = this.speed_options[newSpeedIndex];
        } else {
          /**
           * Modo circular sólo en los extremos, sólo circular en << y en >>
           */
          newSpeedIndex = 0;
          this.speed_value = -this.speed_options[newSpeedIndex];
        }
      } else {
        newSpeedIndex =
          currSpeedIndex === this.speed_options.length - 1 ? currSpeedIndex : currSpeedIndex + 1;
        this.speed_value =
          this.speed_options[newSpeedIndex] == 0 ? 0 : -this.speed_options[newSpeedIndex];
      }
    }
  }
}

export default AbstractHTML5Player;



// WEBPACK FOOTER //
// ./src/devices/all/AbstractHTML5Player.js